// extracted by mini-css-extract-plugin
export default {"btn":"button_btn__7csCi","primary":"button_primary__3Fk-v","secondary":"button_secondary__8Wy4s","medium":"button_medium__OZD22","small":"button_small__tzEGi"};